<template lang="pug">
div
  //- Popup header bar
  .addUnit__popup__return(@click="closeModal")
    van-icon(name="cancel")
  .addUnit__popup__title {{ $t('addUnit.info.connectNetwork') }}
  .addUnit__popup__close(
    v-if="setWifiView"
    @click="checkForm")
    van-icon(name="save")


  //- List of wifis
    //- .button(@click="launchUpdate") {{ 'Update WS' }}
  div(v-if="!setWifiView")
    .addUnit__title {{ $t('addUnit.wifi.select') }}

    van-cell-group(v-if="wifis && wifis.length > 0")
      van-cell(
        v-for="wifi in wifis"
        :key="wifi.bssid"
        @click="selectWifi(wifi)"
        is-link)
        template(slot="title")
          Coverage(:signal="wifi.rssi")
          span.van-cell-text(:class="{'text-brand': device.ssid === decodeURIComponent(wifi.ssid)}")
            | {{ decodeURIComponent(wifi.ssid) }}

    //- .button-bottom-group
    //-   .button-bottom.text-danger(v-if="connectedToWifi", @click="clearWifi")
    //-     | {{ $t("addUnit.info.clearWifi") }}

  //- Set Wifi
  div(v-if="setWifiView")
    .addUnit__title {{ $t('addUnit.wifi.setPassword') }} {{decodeURIComponent(wifi.ssid)}}

    van-cell-group
      van-field(
        border=false
        input-align="center"
        name="password"
        v-model="wifi.password"
        v-validate="'required'"
        data-vv-validate-on="change"
        :type="passwordField"
        :icon="passwordIcon"
        :data-vv-as="$t('addUnit.wifi.password')"
        :class="{'error': errors.has('password') }"
        :placeholder="$t('addUnit.wifi.password')"
        @click-icon="togglePassword")

    .auth__error.padding-halve-top(v-show="errors.has('password')") {{ errors.first('password') }}
    .auth__error.padding-halve-top(v-show="passwordError") {{ $t('new.addUnit.incorrectPassword') }}

    .addUnit__title(v-if="advanced")
      | {{ $t('addUnit.wifi.setSetting') }}

    van-cell-group(v-if="advanced")
      van-switch-cell.van-hairline(
        v-model="setting.dhcp"
        :title="$t('addUnit.wifi.dhcp')")
      van-field(
        v-model="setting.ip"
        border=false
        input-align="right"
        :label="$t('addUnit.wifi.ip')"
        :disabled="!setting.dhcp"
        placeholder="192.168.0.0")
      van-field(
        v-model="setting.mask"
        border=false
        input-align="right"
        :label="$t('addUnit.wifi.mask')"
        :disabled="!setting.dhcp"
        placeholder="255.255.255.0")
      van-field(
        v-model="setting.gateway"
        border=false
        input-align="right"
        :label="$t('addUnit.wifi.gateway')"
        :disabled="!setting.dhcp"
        placeholder="192.168.0.0")
      van-field(
        v-model="setting.dns"
        border=false
        input-align="right"
        :label="$t('addUnit.wifi.dns')"
        :disabled="!setting.dhcp"
        placeholder="8.8.8.8")

    .addUnit__message.link.text-gray3.margin-halve-right(v-if="!advanced && setWifiView" @click="toggleAdvanced()") {{ $t('new.addUnit.showAdvancedSettings') }}
    .addUnit__message.link.text-gray3.margin-halve-right(v-if="advanced && setWifiView" @click="toggleAdvanced()") {{ $t('new.addUnit.hideAdvancedSettings') }}

  //- No wifis message
  .addUnit__message(v-if="!init && (!wifis || wifis.length <= 0)")
    .addUnit__message__title {{ $t('addUnit.wifi.notWifi.title') }}
    | {{ $t('addUnit.wifi.notWifi.message') }}
</template>

<script>
import i18n from '@/locales/i18n';
import BluetoothService from '@/services/bluetooth.service';
import Coverage from '@/components/Coverage.vue';
import AppError, { getErrorId } from '@/services/error.service';
import { hasProp } from '@/utils/validate.utils';
import { WIFI_STATUS, APPNAME } from '@/app.config';
import SocketService from '@/services/socket.service';
import Vue from 'vue';
import { validateWebserver } from '@/models/webserver.model';

export default {
  name: 'DeviceConnect',
  components: {
    Coverage,
  },
  data() {
    return {
      init: true,
      setWifiView: false,
      advanced: false,
      passwordField: 'password',
      passwordIcon: 'hide',
      passwordError: false,
      wifis: [],
      wifi: {
        ssid: '',
        bssid: '',
        password: '',
      },
      setting: {
        dhcp: true,
        ip: '',
        mask: '',
        gateway: '',
        dns: '',
      },
      loading: null,
      connectedData: {},
      connecteToWifi: false,
      connectedToCloud: false,
      updatingWS: false,
      timeoutUpgrading: 0,
      webservers: [],
      bluetoothError: null,
      isLoading: false,
      mver: null,
      wsver: null,
      appName: APPNAME,
    };
  },
  props: {
    device: {
      type: Object,
      required: true,
    },

    connectedToWifi: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    /*
     * Get Device Wifis
     */
    async getDeviceWifi() {
      try {
        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('general.loading'),
        });

        // Inicializo valores
        this.wifis = await BluetoothService.getDeviceWifis(this.device.id);
        console.log(this.wifis, this.device);
      } catch (error) {
        // Obtengo el error
        const bluetoothError = getErrorId(error);

        const errorID = i18n.te(`errors.${bluetoothError}.title`) ? bluetoothError : 'default';

        this.$dialog
          .alert({
            title: i18n.t(`errors.${errorID}.title`),
            message: i18n.t(`errors.${errorID}.message`),
          })
          .then(() => {
            this.closeModal();
          });
      } finally {
        this.init = false;
        this.$toast.clear();
      }
    },

    /*
     * Select a WiFi network to connect
     */
    selectWifi(wifi) {
      this.setWifiView = true;
      this.wifi.ssid = wifi.ssid;
      this.wifi.bssid = wifi.bssid;
    },

    /*
     * Toggle advanced WiFi network settings
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },

    /*
     * Toggle the password so that it is visible
     */
    togglePassword() {
      this.passwordField = this.passwordField === 'password' ? 'text' : 'password';
      this.passwordIcon = this.passwordField === 'password' ? 'hide' : 'show';
    },

    /*
     * Set WiFi network
     *
     * Check device wifi status
     *
     * 1 - Device try to connect to the WiFi network
     * 2 - Device success connected to the Wifi network, now device try to connect to the cloud
     * 3 - Success connected device to the Cloud
     * 0 or 4 - Device could't connect to the WiFi network, it could be by the password
     *          If device was connected to the WiFi network, it lose the connection
     * default - Some times device is very slow and don't return any data => status = undefined
     */
    setWifi(deviceInfo) {
      const status = deviceInfo.wifi.status;

      switch (status) {
        case 1:
          break;
        case 2:
          this.connectedData = deviceInfo;
          this.loading.message = i18n.t('new2.addUnit.connectingCloud');
          break;
        case 3: {
          this.connectedData = deviceInfo;
          this.device.isDeviceConnectedToWifi = true;
          this.device.isDeviceConnectedToCloud = true;
          if (this.appName !== 'dknna') {
            this.closeModal();
            this.loading.clear();
            this.$toast.success({ mask: true, message: i18n.t('new2.addUnit.successConnected') });
          }
          break;
        }
        case 0:
        case 4: {
          // si error, cancelo
          if (this.appName === 'dknna') {
            this.clearTimeoutAndListeners();
          }
          this.device.isDeviceConnectedToWifi = false;
          this.device.isDeviceConnectedToCloud = false;
          this.loading.clear();
          this.$toast.fail({ mask: true, message: i18n.t('addUnit.wifi.notConnect.message') });
          this.passwordError = true;
          break;
        }
        default:
          break;
      }
    },

    /**
     * Compruebo si los datos del formulario son válidos
     */
    checkForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.connectDeviceToWifi();
        }
      });
    },

    /*
     * Connect device to WiFi network
     */
    async connectDeviceToWifi() {
      try {
        this.passwordError = false;

        this.loading = this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('new2.addUnit.connectingWifi'),
        });

        if (this.appName === 'dknna') {
          SocketService.initLinkProcess(this.device.mac);
          this.startTimeout();
        }

        await BluetoothService.connectDeviceToWifi(
          this.device.id,
          this.wifi,
          this.setting,
          this.setWifi
        );
      } catch (error) {
        // Obtengo el error
        const bluetoothError = getErrorId(error);
        const errorID = i18n.te(`errors.${bluetoothError}.title`) ? bluetoothError : 'default';

        if (this.appName === 'dknna') {
          this.clearTimeoutAndListeners();
        }

        this.loading.clear();
        this.$dialog
          .alert({
            title: i18n.t(`errors.${errorID}.title`),
            message: i18n.t(`errors.${errorID}.message`),
          })
          .then(() => {
            this.closeModal();
          });
      }
    },

    closeModal() {
      const mver = this.mver ? this.mver : this.device.mver;
      const wsver = this.wsver ? this.wsver : this.device.wsver;
      const wifi =
        hasProp(this.connectedData, 'wifi') && hasProp(this.connectedData.wifi, 'ssid')
          ? decodeURIComponent(this.connectedData.wifi.ssid)
          : this.device.wifi
          ? this.device.wifi
          : null;
      const rssi =
        hasProp(this.connectedData, 'wifi') && hasProp(this.connectedData.wifi, 'rssi')
          ? this.connectedData.wifi.rssi
          : this.device.rssi
          ? this.device.rssi
          : null;
      const ip =
        hasProp(this.connectedData, 'network') && hasProp(this.connectedData.network, 'ip')
          ? this.connectedData.network.ip
          : this.device.ip
          ? this.device.ip
          : null;

      const isDeviceConnectedToWifi = this.device.isDeviceConnectedToWifi;
      const isDeviceConnectedToCloud = this.device.isDeviceConnectedToCloud;

      const data = {
        mver,
        wsver,
        wifi,
        rssi,
        ip,
        isDeviceConnectedToWifi,
        isDeviceConnectedToCloud,
      };

      this.$emit('closeModal', data);
    },

    /**
     * Inicia un timeout de 2 minutos y lanza error si el socket no responde ningún evento
     */
    startTimeout() {
      this.timeoutUpgrading = setTimeout(async () => {
        console.log('Finish timeout. No se ha obtenido respuesta del websocket');
        // Lanza un error si aún no se ha obtenido respuesta desde el socket tras un tiempo
        if (this.updatingWS) {
          throw new AppError('timeout', 'Timeout upgrading webserver');
        }

        if (
          this.connectedData &&
          this.connectedData.wifi &&
          (this.connectedData.wifi.status === WIFI_STATUS.WIFI_CONNECTED ||
            this.connectedData.wifi.status === WIFI_STATUS.CLOUD_CONNECTED)
        ) {
          await this.upgradingWebserverFinish();
        } else {
          this.clearTimeoutAndListeners();
          this.loading.clear();
          this.$toast.fail({
            mask: true,
            message: i18n.t('addUnit.wifi.notConnect.message'),
          });
          this.passwordError = true;
        }
      }, 240000);
    },

    /**
     * Captura evento de actualizando para que siga mostrando 'Actualizando' y resetea timeout
     */
    upgradingWebserverStart(e) {
      console.log('upgradingWebserver => Start Event: ', e);
      this.updatingWS = true;
      this.loading.clear();
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: i18n.t('new2.addUnit.updatingWebserver'),
      });
      clearTimeout(this.timeoutUpgrading);
      this.startTimeout();
    },

    /**
     * Captura evento de terminado para limpiar el timeout y listener websocket. Muestra mensaje de conectado correctamente
     */
    upgradingWebserverFinish(e) {
      console.log('upgradingWebserver => Finish Event: ', e);
      this.loading.clear();
      this.$toast.success({
        mask: true,
        message: i18n.t('new2.addUnit.successConnected'),
      });
      if (this.updatingWS) {
        setTimeout(async () => {
          await this.getDeviceInfo(this.device.id, this.device.webserverName);
        }, 2500);
      } else {
        this.closeModal();
      }
      this.clearTimeoutAndListeners();
    },

    // launchUpdate() {
    //   document.dispatchEvent(new CustomEvent('upgradeActive'));
    //   setTimeout(() => {
    //     document.dispatchEvent(new CustomEvent('linkEnd'));
    //   }, 3000);
    // },

    /**
     * Limpia el timeout y listener websocket. Oculta 'Conectando' y 'Actualizando'
     */
    clearTimeoutAndListeners() {
      console.log('Limpio timeout y listeners websockets');
      this.updatingWS = false;
      clearTimeout(this.timeoutUpgrading);
      SocketService.finishLinkProcess();
    },

    /*
     * Get Device Info
     */
    async getDeviceInfo(webserverID, webserverName, webserverError) {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading || webserverError) return;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;
        this.bluetoothError = false;
        console.log('getDeviceInfo');
        // Obtengo los datos del dispositivo
        const webserver = await BluetoothService.getDeviceInfo(webserverID);
        console.log('webserver: ', webserver);
        // Obtengo los datos del calor auxiliar y la entrada digital del dispositivo
        const response = await BluetoothService.getDeviceParams(webserverID, [
          'auxheat_enable',
          'auxheat_ton',
          'auxheat_toff',
          'auxheat_tdelay',
          'auxheat_lockoutenable',
          'auxheat_lockouttemp',
          'auxheat_extheatsource',
          'auxheat_emergencyheat',
          't1t2_enable',
          't1t2_nc',
          't1t2_ondelay',
          't1t2_offdelay',
          'rs485_mode',
          'rs485_availablemodes',
          'ecobeesb',
        ]);
        console.log('response: ', response);
        if (response && response.params) {
          webserver.params = response.params;
        }
        console.log('webserver after params: ', webserver);
        if (webserver.general.ble_version >= 2) {
          // Pedimos y asignamos parámetros ecobee SB si tiene ese servicio y está activado
          if (webserver.params && webserver.params.ecobeesb === 1) {
            const ecobeeData = await BluetoothService.getDeviceParams(webserverID, [
              'ecobeesbclientid',
              'ecobeesbclientsecret',
              'ecobeesbthermostatid',
              'ecobeesbstatus',
            ]);
            webserver.params.ecobeesbclientid = ecobeeData.params.ecobeesbclientid;
            webserver.params.ecobeesbclientsecret = ecobeeData.params.ecobeesbclientsecret;
            webserver.params.ecobeesbthermostatid = ecobeeData.params.ecobeesbthermostatid;
            webserver.params.ecobeesbstatus = ecobeeData.params.ecobeesbstatus;
          }

          const resp = await BluetoothService.getWsServices(webserverID);
          if (resp && resp.services) {
            webserver.services = resp.services;
            // Pedimos y asignamos parámetros Pelican si tiene ese servicio y está activado
            if (webserver.services && webserver.services.pelican === 1) {
              const pelicanData = await BluetoothService.getDeviceParams(webserverID, [
                'pelicansite',
                'pelicanemail',
                'pelicanpass',
                'pelicanserial',
                'pelicanstatus',
              ]);
              webserver.params.pelicansite = pelicanData.params.pelicansite;
              webserver.params.pelicanemail = pelicanData.params.pelicanemail;
              webserver.params.pelicanpass = pelicanData.params.pelicanpass;
              webserver.params.pelicanserial = pelicanData.params.pelicanserial;
              webserver.params.pelicanstatus = pelicanData.params.pelicanstatus;
            }
          }
          console.log('webserver after services: ', webserver);
        }
        const updatedDevice = await validateWebserver(webserverID, webserverName, webserver);

        this.mver = updatedDevice.mver;
        this.wsver = updatedDevice.wsver;

        this.closeModal();
        this.$toast.clear();
      } catch (error) {
        // Obtengo el error
        const bluetoothError = getErrorId(error);
        const errorID = i18n.te(`errors.${bluetoothError}.title`) ? bluetoothError : 'default';

        this.webservers.map(webserver => {
          if (webserver.id === webserverID) {
            Vue.set(webserver, 'error', i18n.t('addUnit.info.deviceErrorConnect'));
          }
          return webserver;
        });

        this.$toast.clear();

        this.$dialog
          .alert({
            title: i18n.t(`errors.${errorID}.title`),
            message: i18n.t(`errors.${errorID}.message`),
          })
          .then(() => {
            this.disconnectDevice(webserverID);
          });
      } finally {
        this.isLoading = false;
      }
    },

    /*
     * Disconnect bluetooth device
     */
    disconnectDevice(webserverID) {
      try {
        BluetoothService.disconnectDevice(webserverID);
      } catch (error) {
        // Obtengo el error
        const bluetoothError = getErrorId(error);

        const errorID = i18n.te(`errors.${bluetoothError}.title`) ? bluetoothError : 'default';

        this.$dialog
          .alert({
            title: i18n.t(`errors.${errorID}.title`),
            message: i18n.t(`errors.${errorID}.message`),
          })
          .then(() => {});
      }
    },

    clearWifi() {
      try {
        this.loading = this.$toast.loading({
          duration: 0,
          mask: true,
          message: this.$i18n.t('general.loading'),
        });

        BluetoothService.clearWifi(this.device.id, this.statusClearWifi);
      } catch (error) {
        // Obtengo el error
        const bluetoothError = getErrorId(error);
        const errorID = i18n.te(`errors.${bluetoothError}.title`) ? bluetoothError : 'default';

        this.loading.clear();
        this.$dialog
          .alert({
            title: i18n.t(`errors.${errorID}.title`),
            message: i18n.t(`errors.${errorID}.message`),
          })
          .then(() => {
            this.closeModal();
          });
      }
    },

    /*
     * Set WiFi network
     *
     * Check device wifi status
     *
     * 1 - Device try to connect to the WiFi network
     * 2 - Device success connected to the Wifi network, now device try to connect to the cloud
     * 3 - Success connected device to the Cloud
     * 0 or 4 - Device could't connect to the WiFi network, it could be by the password
     *          If device was connected to the WiFi network, it lose the connection
     * default - Some times device is very slow and don't return any data => status = undefined
     */
    statusClearWifi(deviceInfo) {
      // Set null to ip to not show ip
      deviceInfo.network.ip = null;
      this.connectedData = deviceInfo;
      console.log('statusClearWifi: ', deviceInfo);
      this.closeModal();
      this.loading.clear();
      this.$toast.success({ mask: true, message: i18n.t('addUnit.info.clearWifiSuccess') });
      // switch (status) {
      //   case 1:
      //     break;
      //   case 2:
      //     this.connectedData = deviceInfo;
      //     this.loading.message = i18n.t('new2.addUnit.connectingCloud');
      //     break;
      //   case 3: {
      //     this.connectedData = deviceInfo;
      //     if (this.appName !== 'dknna') {
      //       this.closeModal();
      //       this.loading.clear();
      //       this.$toast.success({ mask: true, message: i18n.t('new2.addUnit.successConnected') });
      //     }
      //     break;
      //   }
      //   case 0:
      //   case 4: {
      //     // si error, cancelo
      //     if (this.appName === 'dknna') {
      //       this.clearTimeoutAndListeners();
      //     }
      //     this.loading.clear();
      //     this.$toast.fail({ mask: true, message: i18n.t('addUnit.wifi.notConnect.message') });
      //     this.passwordError = true;
      //     break;
      //   }
      //   default:
      //     break;
      // }
    },
  },
  created() {
    this.getDeviceWifi();
  },

  mounted() {
    document.addEventListener('upgradeActive', this.upgradingWebserverStart);
    document.addEventListener('linkEnd', this.upgradingWebserverFinish);
  },

  destroyed() {
    document.removeEventListener('upgradeActive', this.upgradingWebserverStart);
    document.removeEventListener('linkEnd', this.upgradingWebserverFinish);
  },
};
</script>
